var _defs, _rect, _g, _g2, _g3, _g4, _mask, _g5, _mask2, _g6, _g7, _mask3, _g8, _g9, _mask4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 601.06595004472 467.29890073843285",
    width: 1202.13190008944,
    height: 934.5978014768657,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }, "\n      @font-face { font-family: Excalifont; src: url(data:font/woff2;base64,d09GMgABAAAAABn8AA4AAAAALRAAABmoAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGhYbiw4cegZgAIEUEQgKw1yyIAtSAAE2AiQDgSAEIAWDGAcgGwsjo6K08R2T/dUBb3j6FM9DohnE4xYLckplkRxnaOZh2NVIhgj3Pdgybl7XjJBkdnh+br3fa7aGXrORSxn0GkaNkoiQCu0To8CoRtSLwooLtDHqwoigeP5G87bPGFieBEEJHxyoZN+v7VOtiWlyqczs7mNohFJI6Q6JpET+hwMM6bSS/jrpnwcsK7BgSLJA8VEOAAwHFZbPRSO3UjsgsB0SmAK3ceIALR/wjzRP4IQD1wsceZw+DvRdLZ3NUZo7InEpytCEwZn8U/cv3V0orctLaK5XYRgsrpb/h65SqntkHErgBBYhcbI4izoZ2goRuIXl4xQ/Jj81TMncUAmu1Zlk49ejJ4AAQAMrbGpG+YIeBIZCJQa62xLSgfvV1VwH3O/m8lrg/ha3NgB3KAAAN7o85c0NgCTOtzqB1304EAlIJqAfDkL/a4JPsDA3CZxnn7OP7LvGAXWVxz2wajkIbjNBZaLpU2Auv62XEQlwl5DVVxa+428K23+TeBx5I64AdkzBMah5uymA94RtZh2Mh3fk8RwAhOIAwFBAaNgIXHwMbsQsHvuzeRPikPLFZ4iNfAKXE+hegBSCka+yAg9GLigXOigTj4h8CgZHwcJAxUaglQApIDMz+OWxQQ3AQQkkHSiBWQDQV3iAixPmAVhUswHEAW5ZSLcUwiaQQ+7SKQAiQT4E1DAMJ5AygighmIcpQbBjlDfGiHh+WgCJsyUq7a2uLEYQhXGhhoD+ED4W/IJfIQaG8MtRYCKAy0tLh/pgSM3sBgCI3+0SOoHGx+AxrVMthz0JDBHq2tq/2rBPN6hdCKx5i/zUWIR1RSMCAO5OoB1GTfSPJyYEjZBcIJtETmkyZKrWqEPXhxfYKCE2VVOsVvPHwFbs/zJ3HDt0YN+eTRvWraU6NEN/1YxVIKdK15N6ptBbCiykDzHiJm8jzMLZwVzL9UO2rfTh73NTNfgc+tNrz0/9882Fzx87+9d3q3+/AUq48sRvZ8H79efzE28U33jemJr7XeWZj19/+e1XX67df52Xltkg0Z2flRQpZeLgVcUVuQLJvfgijaiyNJ+pQEYhD7JHHzsn5oYslQjCAYYfWDTSU2P9/rp/E2lkExCXuNRtjEp9HLzOdedF+gDS7Qj2cu6jJN6pRY5Gf7YRu4zYKmrmmYZCUQg1+2c4Dg8B+Q7YaudK4877CpcbW1tmcxENytjp5apkyQXLS0KhuhNRSiElgDzaG1KFtr1oIJ864+T8sROMz6v1IQIMBSD0E7tuZyiO+2ilnOjOi6/qnXozy+Q0xyXNtm3GGIpVtclxOo3Se2k6m2JZVAmB6TUdboqqsCR5kBxsmJni+1nJnicptEB65xUnivCD98JBfT17+L5SfmJnT+1nU5lJO6hUdCfCOg9wYlCDwltuwtV2EGIIdc75iPVjYI/CLhkCwZQUOtJjne5BaoHuPTThZf8CT8Z6OYLlcqIjG7F1P1PVjpxiA4xQ9lrPB7oDYQTTXy3tpUXidplEdt8UuOuJ+RdeaEjjJ5ir+U52/FQmjUIvzaVMY17OAqAWIwLCOZZvNLg0VdZRO9M8SfA2dsbJt5g/GOu8UoERLFYhIWLHIAMRuwCIVKLriZRlRenbcC/nFciOdt+rhgKQHY0oY+kkDk6kLkk9QMBIFMjdu4CMUK2PmMrUhy53Xh/LR741mox1BzpHOeoCghBDGchIIwAo1qQDX6Q6olOGnGLUBkSAUBTsXaCVgMgpywXyiZ0BccpG8e3plSvSFqXZbDK0iMe6Y4jskgDEbQNaiXSnLM+URzSCNKJUUZYW/kxiFK+vID/LsyzfRL7mbgrQnd+vs/Wb6LpAzBuaBJswEF/3zcHzXG5IM5BmVHsx6hmUQlizIJd4q8GCAXYiCGkP0hR6lpGS3oK0W9tXLRq0Wo9R3/RPlrrSItUjPY3pl3vUBcNHd0Vh9PDdKgHE9XJLlyghLjj8OJFlniSCnTdTSOcY7WQlO36gxBYgwtCdP9to/7l+NveDfNMPMK8cVZwH43F5cLP0jXY0u0rb1FMEaQrbE+4hGuVX6lJ+gw8SjG+awbfFHrxXc2CF6ulWtaZQN81EHoQjAZQejNIihNBRZnuG1XYB+UwoRvuqP8DjWTq796KTyvJJ3s9Qpp3+nH8+WHDGOh8kB72ibyOSLz9GPVcZluxYY2EIQgFEVfH2Upjyy4mWmP/qYT+crY7rHWk2JeZBgHkC6VqObLZ8t5+7bKwdFSPdwTwXW/mANhwoMiUO8s2O6i+MZ+kaIMtWzhIXidVePQWphXOIqdjs1JtTHZVNqcFJkV/6FT3bNjwIKcb8iswEZoALS6ipoqxUlGU6NzeubE2vNm7cQI7Z5NjkulOkhgVbFzdzw6qIEjE8zbkzpMRQPIf65/JNBqrdeSAJa2E2x5hPSU28KE8WOD7RnRqNKIARpOE+eA1CQkD4MBMuQsivC6/ulL9d3yk0F0u6yH43vNi91PvkrjJlhUYgz3POMdedyZbICQ4eeRByXt1OJ7zN7oyQrAS3S7Fmv0EIJNSi+PXhvYg9sndQtltvLN55+kRWkr3erOflXGCHDHUQ2wGjny5aLQ96r0ZpuUF7ivXoqGbPMeRnpirfte3UwNONab4aLOJAqkGZ7kHvbNWquiKnGNe8tRR6gGh26bh+WhWXu2od6Q6WRmItOwhbkc9Lwwm8559dFi+Emv1ayVWW05e3Xy8nLyeGcjhfECOhzCKd0shx9OTEDF4r2bvdmVyNRdyfgLIAQ1nBHxT5Nq53GovvDxb4GNe2IaUetDwXuCXWR/G8HaIdURUluJ0Wv27RboFodoZ2NLug5JRWalgk/OIbxXE/3ykPdAfSW72ig5MtiQNp3g3aL+1nU6ty4UB3nrWApdmIvRTvDmcIICQiJUa6I3805ViPLkHUFjmB1ubFYRnjsdJ6ls/q4XddAYaPEs2+zNSm3+R4Ua5k+dXs/HnGOadUVyAihZWekZbozuxRejbNWqRd8jGJv0FxxwwOipRTvBLSJ2kLfBDO9RHLMuSbQYUaVttbhlbLVQS6HsgyP+BJerStgVtEQ/BdlJLvXklJywnsVbsPZ2J91NQ0InKtwii/Ps2DQOUd9aFOJvO8mFyz0tTwlBqtVRyK6Pgr6qqcXpHnAt2ZtSisUWVJCMVL222DAlIb5ZmvqoHu9KDhnr1TGOQPitElZSDNjfL27Jc1t91GJQlR/GhAh62ovka6rQKAJ0CeR0AYI6aqGgMC5BNtDSgrs445+pp9HUUi55aeUgOJm3mmNgfQMTzFail8YwPzwQAPHuHRGjVSV7PaigdIWLv/3F+farAmPmgc6E76bDoUIKPwfsORcpr5PuujLGiDEJAu2M0Rt63QNRh9SEhd3iVTM2tK9tr/9Xr4hS7lz2iJl0bZU5olFEEv1/3YuSLVv//CbtV7bK8Sfby1cPLyg2lPsUBXs2OkjWZmhoC8uy4Z1CMuyQUVx/l6hy81gzKPIKWKVWvwAN9b0u3t6IHulHmA4gwlyBE+6iy8Lc2JnLj2XHvGvktGYQiIC/fS2dRZ1buvx3c+2ZljNztmVgmmfBQCe4TKCtlsES+MX8bqoNIzaAqLyYOkUtme6JbPDnseFOd+1iUalTkA6xKDIqeGsQSG3e9eIaNP7DhGzGexZBUYkvrsGPkrvlS5qrLzfID5tu7T88BQWbpEI6o7F6RNL/LHqvNZPuxNWKBlpZPtGVKzGerfvpzl/ec6pqEXDsr8yEhpeF4PUsxP+AYfBDiY3rrAi1SnjDCR3EJ3kQoIabLtmh1KGXjdX1nJ55u++ipmTR7rp/WgoiybpDofbGAcbFnFyw71IAuuGdQoD+5Ik9/gT3Me4d5ExezhXe0Hia+N1lV1oxHI6VNPs+f2635zVZqLugN7OTKzVPOOijwZBBv5v4kHnOM8eUrvmSpxFSJAS1wl5FuTcwsNdlhAeWTgxk45qZRFfaPZ5UJY0sqgf1ZamoROmjwYl2Wrtzn/km2DuBBqHp70OhmY/gNzVluj8mli3fZP3oorKmnZxp9UE6rzusrR8kfCVzb/24Ga2/Sv5YrNGPRzDZ6kyJ90vfxT63vB+eKPJE3/Gzwxk8zsj2lJr5JFlL6At69g5CM215E/Y88cHdbjAwet/F2KWeRIUH2BtXy7lyD2lYD7bi9xt2jt+pIj2XcqJs7nF/n2nbQANy39wKPWONqwJ2VxBrTQMp2/jEul3cM1P5WVbWFulXCc5wsy37ate7060Gr+wM2DJkNjGvdyfwZEtYvEG4cguMR9GQNm9x+ZJoOo0Lb/VNpEVhxGSucsP7UJf4M3Ck0tl/eXqYJAZtAHkfm6KrtxFTADU0yCBSesWIyorTHh9O8RfPLsLuQwY4iKzAE2tKHMh3eBgrBJt/uPmgMxLXzTGA85Nc30rhyO3edNXTpumRKXZ/Rmylkm9k+G9BU/NFpMmJPOLJg0X/FUquExzRXcrg47IiavcGMuN3hyy5Aex7tJ8IJU1dFUt+hpPFtbbtjH6FYyNRa+ChZBEVMVwz+YMlbzqnPnm3KMnpUtQhxuZ6LwPZH1fcME33Enk+Hf3avMLCaAzu+3VqXPyh9mUfIeP3trzVma5NQZGzwXACQVX4hwGLaMLrfOlInxriBO9IL0Y2/ZhX3wXmdT6uAgjrHaPuZUUmwwRUA6bCcfhYAkQeD03Rd6w4O64b1ZOF3OmJ6SYUu1SWJ+LLxqv33uatGxu0afMtZsF2mH7UnPGkpFlIZtyyCwFLUjs7Q3t8GTsIz6BTJGQTmoiRPX4JCT034Ba2ncb8w24nMiiWySmURkZxRq72IxFjn5INM+zHuwdf+Cw7t73dfKRi1esvRPLDrkxHq1bGAMahNsNPP3fyknKhsrlAFIgafFZS9l75D5yB+Vo0ZSx6OX2wTJHrJUyQ+TYtELxU0xsI8TZ5a14VgSku5y4X5U95a+uS7DRaeyN0ysTwFtzPUJXDyfduiTA/99k8jRnkoIzw26uG4S9GSGXzq674ct6c5e+p+20rnw5GVnoxPLyEWcIjJc7yWxEFS3UW7qx/8XMZpGekUypIhF/JuBF5whPHZtBe+Z5F7GQDmpPxYNehKnkuboO3kOtX9BAAkvhB4sCaRyNtAdmx9nvVbme3LI2Q0PpSIoB89cmzordRxgeVSMJyO1QeB07PC9Mw7nO8N2TvGyQGJ0KyCUyESLwFrY0JIlNo4KDoPILqM9nBHrxDbwk+gUcklTxJu0uGtdUrwkjcSz5Jk5C367RyUu2qcfh8dKZVH/IM3bfTJzl+BZ/EY+QJv71zE3Wr8nx0BgYDJRG7KGj2L2cFDByQ+ETJQch8fchP/gNMWPXQaD3p1+IGNlBr4Sr+eUSOf52wp4g/Eg0/b+3inXsjEm6Ryta0K4AAjpeHR8PwwGprNbWPdi3hxpF0wFVGBLidjDks4P3oAa7+gltwHNvQSmeICxEOmi/vp/VRnOlgTbR47o2NclonMGnvDvr/R1su3B4/yuB+iMbM6LsCwauQHdBGPxeqGQw3uF7CimtJH2wPafIYuY69KSYXyGKou1ByriMafEiU2S5ARm2PVXPV12Dn54OF1DHTFhk/Cs3iinPdKyjA1BwoqJGFNpLQducAucJN6yPVfCDLojX6KGtr+Wx0AO8sO+JWlWdUa9b0+Ey+VVe5ucKqgH+eH2rIl20Dz/o+nQopLeGCrW1wvnQU5OlWr3WN2BRE8KfmhFvE9Lnz46aWrBG2NEfTkIwj0PJ7l6/s7JKcJn1iOyRjmiHKWd+WzobbuaZ3p/g0xQnD6OXlnDgzNK8f0FtFENnRUVN5XzNkjGOQRwsh+HBQ8hS5Vo0wylGyMjqChAMa9tzpvKGQzzvnbBAbCYKouaFcfxCqlGy/n51d7+b0ssFt2Ht4w6vZtTZxMWbY+TfaeypX2fOWdNvyt71pnfJKzKBFU75fn9aPv7/49Kk5fSYUgL4eDuFwGP3qonKforhub6usV62AyxkvgQ8r2/35ozS1IsPdPlxUnoNJXBkTDn6Zkz4DB+z+gqn1NzJTmD5wf5WX8MKBP3x7okE6zq5YazeblzBUkCca7rHEYy+glg/iVbbUekum18o6+5Kd2Uz7oMjS2PRToJnQPVLsgabESr3QGFWmZXOoLIeVDaODzdg/eUzqu5zlpC8XyOuUzzdJmNOCdK73vHLvcJcooNjTOWJOjU2aOZJ7pPnkhn2V8/XB0gTSb/bruZcYaVA/LoQ+4pL0uZ1z7itoZ5k/mFvvdjTogqhqNlJ4aQc29Czy160P9CofsZNoVvfKX5lAjtq8WadYRrZz7YzFafGtn9AU+JJMjJU7qTaHcciiiEQLoIXMUvS2IzC+CIH56neizRAaeMViv1SZTGFAdnenrEOLwf6Qlu/VO3hgYXe9yRE7qNjQdEgneZAZGLeOtgOzm9XAt8Rx+VVtREpSS4viwdakqJlqMp2Qifp627eYqxpSRhCmfSiWvmZpmYe7fXyU9JRk1KiyTnYQfW8sZI8YLT/tHObeJxz2gq14EBSv/7aZOV3Ty2eWL3lmzeBIkPsy9sEKrlu6XMdNUNtixodsI9m6dsf8fG6tQDt58VH5WuTYPaVWH6ZnoSKfbc8bixnHfnl0T5g1c8DzNvrVzg1k7CSAbPCVTieiLgtnNsITn1K2LckooF7J8t89+JETAymZxYwEZT4Lmj1OHTwmIp+qyqd0khdoBRVVSs46DV+eVlrU1sCQ+P217xE+uaVGjiFvqQ2lchW3qlwMOwMtmnmtEhLFtxPeA+eMEjyS/4NwtczPd/Vtbq4qrotEtUwXQxQFB6sFYFx7ORXJjP+KzkYAZTf9FeCHwDc5+Avoomim05jalaPl8Uy/XJWuOZ5QeFsK1NYN6hux+8hJTNk4s5LGfqopjpmm5JFxTKymRNcz27EdC9PAgnkUW4ez2QH/uLVz/mfCBJHAzBwcoasMXjaql1tlH132YaC69EcNv7w63OI1PA4xORRTlxXod3DY+3MkwjcLtvcZnY7wcIJuFwvvpSgPXEtK9IrYJN6iK89EgdZKPMVR2UYnAyXi3LlUDrY8EkjuDETWicK52gUE+6w9Q/A7r4nj7wBAyxU+iB9B+JRXEQYhXu2UDvPgG6wcYi6Wr4VRif1p9bqF/56V6W8oc33JAWTmTanSt7FjqGSNlQ5u9eK+S0jsPp3xqGMwPHwqVkdZqlk7UqeZU24ckC+Hp0JrUFVoNRCdrCWWAQprixKyrZxjz57liBGCeJjCH6VE5QUtM6yy8+cdRFXlgiQmaanwuP1PgzQiDzvouS0WMkIzGiDTV9tfu87RnsFOQQ5P5QWAWuo37Vv8V9Qqtr/Kp3GxVLox3To09obbui68d5vilvVAnjFaP5cQYb1bi2EhKnBwX4HPuJld5vIfn6UyFK/fN9tWBlc2PjyOhfWb52yhYSqHCHUvPIlgnPT3GsdGJBm7cq9gtt/NOGKPFIqm4VSoZ7RURNWNn8ZaMW/xbhwYuLtaXvlr2lxrusGcfoBvMkCxgWLjYgpgm0Yjq0Ya1g0+zcyYVcjOw+J5ZL22ofN4PCkc0EzXz67NDwTXeGIxlIHMKHLcBo5VyUGTSPvDYOxFA9Ty/QtweuTjRluBv1tpJzHnj9/3nSNAwWIS/Ug5b2WF7qVCzl+f62T5cvTH33bDDjRVaIqeAuwWoSjR8PuIbhXNm5gzJqj5wbO9p8+ArZa6Dk2m1zKCeLNmSo/KGKvzHIF2mskKlHBozDm3aAScXvbMwBQb7NxUBJ3uP+tVyneuUcNH5n7agea0fbuLuHhm+kxBT1hCQ6m4TjwQgNJ8KMM+5PKHdNhaN6unyEG/f16rVb+10hKzWDjge95YjVk+yIMAiWysKCU/8qURwhe/3iqPB0KAx/7CIQtGgDQxTsLzegkXT7y8/sbHCTYB358ZQh3825p0PgNQmIIRGQOt8ADWJ2q5027YfVr+59Frtmrl3lfin3wn9p+NIBITqU4ELcNhg7LenW/NkhN4ybWWUis8qIE+A4AxFSz5vuVC2ZOkYbDq2EcTmd5S9mZU4k2lnp+V7jbNgiP3NmvLG54q4ciTOL4nF/ttexoPKV6rR9of9AazJeFMf07bY36RxiU5Ttzzu8Do/UsCpws0W4SCaiFYTO3Rk5/9wVW6jIrfSiR26dsZgSK5ioYL2baMf9nyNFjAD7393Lbl/O/ByaXIlaIuakjXX1FCd2RzXpnsJhskbXvVG7NCFh5CiJOwX8eoNtZhE532PtK6eE8Vv290N11NzpWOedFkJKp+Xj5+yZjFtBX/PxMiee9szw9wAnpe/24Gt3ACM0DKCx99bHQpeINyQqch8AAO50+VkAAODu+kc9375rD/oQDQUAkAAskOcMsmLsIuk/O3fEiFEgJcAK9QEA/wmCoRWAA28c4j4AKtwGBAgN0OEjQAMvAkrYZ1PGV8CFfwJG+DZwwA2ADI+AIIQNIuAYIIf9gR56D4RwPlDCbsADevHtQ/7AHw7ZofcaM55Ad+haoopngNCygCo3IbOSOh+KlKCkdj4d0DsgMDbNLP4K8mA/l+HA3w4A+dgY5+TRORDQIgMA6pxr6iFcv+lhDHv1CD+9epRUiR4TRQo43AWAVadSxepUqzBGg1aBUpWr1KZOsWajgzZrKfledyG1IKoFDWevG7o0qnLuL9KCJkFxIc3yIZTK0xGyyvZukcYuSbgQ23P9EsxJG3UVUC2RKkOgEECZVEPVQRe0RFcwolAmNxbrEARqVMexQnHScgHlicqhHa1lgiAu6xwLAw==); }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 601.06595004472,
    height: 467.29890073843285,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(213.38780866669367 10) rotate(0 89.59620192970124 42.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 0 C57.41 0.09, 94.73 -0.07, 157.94 0 M21.25 0 C71.27 -1.33, 121.23 0.52, 157.94 0 M157.94 0 C171.54 -1.52, 177.46 8.28, 179.19 21.25 M157.94 0 C170.95 -0.21, 178.65 7.42, 179.19 21.25 M179.19 21.25 C180 30.55, 179.2 38.99, 179.19 63.75 M179.19 21.25 C178.82 37.06, 180.03 53.26, 179.19 63.75 M179.19 63.75 C179.58 79.66, 173.2 86.72, 157.94 85 M179.19 63.75 C178.74 79.02, 169.83 84.74, 157.94 85 M157.94 85 C104.59 85.31, 49.43 84.48, 21.25 85 M157.94 85 C110.56 84.88, 60.89 85.46, 21.25 85 M21.25 85 C8.97 85.59, -0.71 78.65, 0 63.75 M21.25 85 C8.43 85.33, -1.43 78.95, 0 63.75 M0 63.75 C-0.17 48.41, -1.13 29.07, 0 21.25 M0 63.75 C0.11 54.63, -0.15 45.25, 0 21.25 M0 21.25 C1.81 8.1, 6.78 1.83, 21.25 0 M0 21.25 C-1.82 7.07, 6.36 1.7, 21.25 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.81406052839793 15) rotate(0 61.16995006799698 37.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 61.16995006799698,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Serverless"), /*#__PURE__*/React.createElement("text", {
    x: 61.16995006799698,
    y: 42.62,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Web-sockets"), /*#__PURE__*/React.createElement("text", {
    x: 61.16995006799698,
    y: 67.62,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Dataflow")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10.041916601388948 187.29890073843285) rotate(0 101.67035676117985 42.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 0 C79.37 0.32, 135.35 -0.66, 182.09 0 M21.25 0 C53.27 -2.14, 84.99 -0.78, 182.09 0 M182.09 0 C195.25 -0.19, 202.87 7.38, 203.34 21.25 M182.09 0 C194.26 -0.41, 202.26 8.1, 203.34 21.25 M203.34 21.25 C204.68 33.99, 203.1 47.29, 203.34 63.75 M203.34 21.25 C203.94 35.92, 204.29 49.7, 203.34 63.75 M203.34 63.75 C202.95 78.88, 194.28 84.77, 182.09 85 M203.34 63.75 C205.5 76.19, 197.65 85.59, 182.09 85 M182.09 85 C139.08 84.08, 94.44 85.8, 21.25 85 M182.09 85 C142.37 85.48, 100.42 85.55, 21.25 85 M21.25 85 C8.26 85.29, -1.24 78.82, 0 63.75 M21.25 85 C9.1 86.45, -0.76 78.02, 0 63.75 M0 63.75 C-1.63 48.91, -1.78 33.75, 0 21.25 M0 63.75 C0.94 52.5, -0.12 41.15, 0 21.25 M0 21.25 C-1.59 7.07, 6.45 1.48, 21.25 0 M0 21.25 C1.63 5.16, 9.25 -0.46, 21.25 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.232328895024693 217.29890073843285) rotate(0 83.47994446754456 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 83.47994446754456,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "React Front-End")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(386.5941799683087 186.73223849526084) rotate(0 101.67035676117985 42.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 0 C75.91 -0.03, 136.25 -0.63, 182.09 0 M21.25 0 C56.76 -1.06, 93.03 -0.81, 182.09 0 M182.09 0 C194.52 -0.36, 202.4 7.97, 203.34 21.25 M182.09 0 C196.54 0.09, 202.91 8.61, 203.34 21.25 M203.34 21.25 C203.78 34.76, 205.04 44.85, 203.34 63.75 M203.34 21.25 C203.37 38.19, 202.58 54.06, 203.34 63.75 M203.34 63.75 C205.22 76.41, 197.46 85.51, 182.09 85 M203.34 63.75 C202.74 77.03, 194.71 86.23, 182.09 85 M182.09 85 C131.6 85.69, 83.22 88.4, 21.25 85 M182.09 85 C129.69 85.73, 75.5 86.04, 21.25 85 M21.25 85 C8.84 86.26, -0.66 78.01, 0 63.75 M21.25 85 C8.4 84.01, -1.98 75.83, 0 63.75 M0 63.75 C-0.05 50.13, -1.02 38.63, 0 21.25 M0 63.75 C-0.73 48.84, -0.25 34.68, 0 21.25 M0 21.25 C1.42 5.41, 8.97 -0.4, 21.25 0 M0 21.25 C1.81 5.24, 9.1 -1.34, 21.25 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468.3645466477028 216.73223849526084) rotate(0 19.89999008178711 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 19.89999008178711,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Ably")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-M7CsqxfJG0FHBbAYc3c-E)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.42454672513668 229.80740073843288) rotate(0 81.58481662158601 -0.28333112158600215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C22.97 -1.5, 50.18 -0.78, 81.3 0 M0 0 C22.76 -0.3, 46.8 0.32, 81.3 0 M81.3 0 C81.74 0.08, 81.21 1.23, 81.58 -0.28 M81.3 0 C80.87 -0.29, 80.99 0.47, 81.58 -0.28 M81.58 -0.28 C81.58 -0.28, 81.58 -0.28, 81.58 -0.28 M81.58 -0.28 C81.58 -0.28, 81.58 -0.28, 81.58 -0.28 M81.58 -0.28 C81.07 -1.25, 80.34 0.5, 81.87 -0.57 M81.58 -0.28 C81.77 0.12, 83.84 -1.65, 81.87 -0.57 M81.87 -0.57 C103.51 -2.04, 124.71 -0.16, 163.17 -0.57 M81.87 -0.57 C108.3 -0.3, 132.64 -0.89, 163.17 -0.57",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.42454672513668 229.80740073843288) rotate(0 81.58481662158601 -0.28333112158600215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.65 7.9 C145.14 3.68, 154.94 1.86, 163.17 -0.57 M139.65 7.9 C145.64 5.23, 152.87 3.39, 163.17 -0.57",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.42454672513668 229.80740073843288) rotate(0 81.58481662158601 -0.28333112158600215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.71 -9.2 C145.33 -8.26, 155.11 -4.94, 163.17 -0.57 M139.71 -9.2 C145.64 -6.9, 152.86 -3.77, 163.17 -0.57",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-M7CsqxfJG0FHBbAYc3c-E"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 481.5941799683087,
    height: 330.3740629816049
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.60941522660596,
    y: 192.02406961684676,
    fill: "#000",
    width: 90.79989624023438,
    height: 75,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.60941522660596 192.02406961684687) rotate(0 45.39994812011673 37.46039291539449)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 45.39994812011719,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Subscribe"), /*#__PURE__*/React.createElement("text", {
    x: 45.39994812011719,
    y: 42.62,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "&amp;"), /*#__PURE__*/React.createElement("text", {
    x: 45.39994812011719,
    y: 67.62,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Publish")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-S3kCyDSCqHfDo0HqK6s62)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.04937559912105 181.73223849526084) rotate(0 -187.51861500576388 -17.216668878413998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.31 -3.54, -1.52 -9.5, 0 -19 M0 0 C-0.59 -5.68, 0.13 -12.13, 0 -19 M0 -19 C1.88 -30.61, -6.15 -34.77, -16 -35 M0 -19 C2.17 -28.99, -6.15 -34.16, -16 -35 M-16 -35 C-138.41 -35.25, -261.18 -36.85, -359.04 -35 M-16 -35 C-121.09 -36.58, -224.93 -36.63, -359.04 -35 M-359.04 -35 C-369.35 -35.47, -375.18 -31.11, -375.04 -19 M-359.04 -35 C-367.62 -33.84, -375.39 -27.56, -375.04 -19 M-375.04 -19 C-373.59 -13.3, -376.67 -8.52, -375.04 0.57 M-375.04 -19 C-374.03 -14.09, -374.32 -8.49, -375.04 0.57",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.04937559912105 181.73223849526084) rotate(0 -187.51861500576388 -17.216668878413998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379.95 -16.53 C-378.69 -10.01, -378.45 -5.82, -375.04 0.57 M-379.95 -16.53 C-378.99 -10.46, -376.72 -5.14, -375.04 0.57",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.04937559912105 181.73223849526084) rotate(0 -187.51861500576388 -17.216668878413998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-367.81 -15.68 C-369.96 -9.53, -373.12 -5.57, -375.04 0.57 M-367.81 -15.68 C-370.8 -9.94, -372.49 -4.9, -375.04 0.57",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-S3kCyDSCqHfDo0HqK6s62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 964.0866056106488,
    height: 317.29890073843285
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.1408466767698,
    y: 134.23223849526084,
    fill: "#000",
    width: 258.77982783317566,
    height: 25,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.1408466767698 134.23223849526084) rotate(0 129.31613986233242 29.68273364728236)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 129.38991391658783,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Publish updates to Clients")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10 372.29890073843285) rotate(0 101.67035676117985 42.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 0 C82.8 2.1, 140.61 -0.67, 182.09 0 M21.25 0 C83.81 -1.94, 145.61 -1.9, 182.09 0 M182.09 0 C195.22 1.92, 204.88 7.14, 203.34 21.25 M182.09 0 C197.92 -1.75, 203.59 8.29, 203.34 21.25 M203.34 21.25 C202.98 36.58, 204.55 48.8, 203.34 63.75 M203.34 21.25 C203.87 34.06, 203.16 47.98, 203.34 63.75 M203.34 63.75 C205.11 78.08, 195.07 84.56, 182.09 85 M203.34 63.75 C202.95 78.58, 197.38 83.17, 182.09 85 M182.09 85 C134.15 83.79, 87.56 86.1, 21.25 85 M182.09 85 C138.99 85.08, 93.51 86.25, 21.25 85 M21.25 85 C5.1 84.28, 1.23 77.42, 0 63.75 M21.25 85 C5.26 83.22, -1.82 79.85, 0 63.75 M0 63.75 C-1.34 49.37, -0.57 33.28, 0 21.25 M0 63.75 C-0.59 49.55, -0.45 33.91, 0 21.25 M0 21.25 C1.9 8.56, 5.96 0.7, 21.25 0 M0 21.25 C-1.46 7.7, 6.47 -0.13, 21.25 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.0603942978014 402.29890073843285) rotate(0 40.609962463378906 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 40.609962463378906,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "Lambdas")), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-P_MluXhGVH6Rk7f1V9Nuq)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.71227336256925 277.29890073843285) rotate(0 -0.02095830069447402 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.82 17.4, -0.95 36.66, 0 44.98 M0 0 C-0.02 16.36, 0.02 31.53, 0 44.98 M0 44.98 C1.92 46.53, 0.05 46.45, -0.02 45 M0 44.98 C-1.75 45.24, 1.19 45.94, -0.02 45 M-0.02 45 C-0.02 45, -0.02 45, -0.02 45 M-0.02 45 C-0.02 45, -0.02 45, -0.02 45 M-0.02 45 C0.13 43.81, -0.48 44.66, -0.04 45.02 M-0.02 45 C0.62 46.12, -1.87 44.9, -0.04 45.02 M-0.04 45.02 C-0.72 57.5, 1.6 68.4, -0.04 90 M-0.04 45.02 C-0.42 55.58, 0.76 66.7, -0.04 90",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.71227336256925 277.29890073843285) rotate(0 -0.02095830069447402 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.41 68.74 C-2.7 76.86, -2.6 86.9, -0.04 90 M-7.41 68.74 C-5.03 76.61, -2.36 83.33, -0.04 90",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.71227336256925 277.29890073843285) rotate(0 -0.02095830069447402 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98 68.98 C6.71 77.15, 0.83 87.1, -0.04 90 M7.98 68.98 C4.88 76.85, 2.06 83.48, -0.04 90",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-P_MluXhGVH6Rk7f1V9Nuq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 211.7541899639582,
    height: 467.29890073843285
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.32135809165993,
    y: 309.79890073843285,
    fill: "#000",
    width: 134.7399139404297,
    height: 25,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.32135809165993 309.79890073843285) rotate(0 67.45899559706868 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 67.36995697021484,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "CRUD &amp; Auth")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(387.7252365223603 372.2989007384326) rotate(0 101.67035676117985 42.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 0 C55.26 2.79, 89.25 2.36, 182.09 0 M21.25 0 C72.37 2.32, 122.64 1.37, 182.09 0 M182.09 0 C197.91 0.89, 204.41 8.92, 203.34 21.25 M182.09 0 C194.45 1.17, 201.34 6.24, 203.34 21.25 M203.34 21.25 C202.13 29.38, 202.23 38.8, 203.34 63.75 M203.34 21.25 C203.01 37.25, 203.32 54.11, 203.34 63.75 M203.34 63.75 C203.22 79.6, 198.24 84.15, 182.09 85 M203.34 63.75 C202.86 77.63, 198.04 86.69, 182.09 85 M182.09 85 C145.11 83.26, 105.26 85.07, 21.25 85 M182.09 85 C144.46 85.75, 107.66 85.01, 21.25 85 M21.25 85 C6.82 83.52, 1.51 78.93, 0 63.75 M21.25 85 C6.05 86.44, 0.86 77.23, 0 63.75 M0 63.75 C-1.93 47.01, -1.56 32.32, 0 21.25 M0 63.75 C-0.47 54.41, -0.13 45.9, 0 21.25 M0 21.25 C-0.07 7.6, 9.02 -1.55, 21.25 0 M0 21.25 C-0.14 8.79, 7.45 1.03, 21.25 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(443.51561891830625 402.2989007384326) rotate(0 45.879974365234375 12.5)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 45.879974365234375,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "MongoDB")), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-YqUJ2tKlBnMGQLF2e4ghR)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.3407135223597 414.80740073843276) rotate(0 82.19226150000031 -1.1368683772161603e-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C32.49 1.14, 63.21 -0.05, 82.19 0 M0 0 C18.2 0.15, 34.59 0.14, 82.19 0 M82.19 0 C83.08 1.07, 84.03 -1.57, 82.19 0 M82.19 0 C83.36 -2, 81.35 -2.15, 82.19 0 M82.19 0 C82.19 0, 82.19 0, 82.19 0 M82.19 0 C82.19 0, 82.19 0, 82.19 0 M82.19 0 C83.87 1.98, 81.34 -0.42, 82.19 0 M82.19 0 C81.9 1.78, 83.88 -1.39, 82.19 0 M82.19 0 C108.88 -0.4, 138.49 -1.96, 164.38 0 M82.19 0 C113.58 0.82, 144.45 -0.12, 164.38 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.3407135223597 414.80740073843276) rotate(0 82.19226150000031 -1.1368683772161603e-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.94 8.67 C151.23 6.74, 159.69 2.26, 164.38 0 M140.94 8.67 C146.82 7.48, 150.81 5.64, 164.38 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.3407135223597 414.80740073843276) rotate(0 82.19226150000031 -1.1368683772161603e-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.85 -8.43 C151.02 -3.88, 159.51 -1.87, 164.38 0 M140.85 -8.43 C146.6 -6.01, 150.61 -4.25, 164.38 0",
    stroke: "#1e1e1e",
    strokeWidth: 2,
    fill: "none"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-YqUJ2tKlBnMGQLF2e4ghR"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#fff",
    width: 482.7252365223603,
    height: 514.807400738433
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.7829979105436,
    y: 402.30740073843253,
    fill: "#000",
    width: 57.49995422363281,
    height: 25,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.7829979105436 402.30740073843253) rotate(0 28.749977111816406 12.11880597637662)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 28.749977111816406,
    y: 17.619999999999997,
    fontFamily: "Excalifont, Xiaolai, Segoe UI Emoji",
    fontSize: "20px",
    fill: "#1e1e1e",
    textAnchor: "middle",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "alphabetic"
  }, "CRUD")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawing);
export default __webpack_public_path__ + "static/media/drawing.8335511753406e4e45f26f951c8b19a8.svg";
export { ForwardRef as ReactComponent };